<template>
  <v-dialog v-model="dialog" width="620px" :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card>
      <v-toolbar color="primary" dark>
        <v-toolbar-title>Chi tiết đơn</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="cancel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-row>
          <v-col cols="12" class="mt-4">
            <CardStudentInfo :student="uniformOrderData.student" link />
          </v-col>
        </v-row>

        <!-- Trạng thái đơn -->
        <v-row>
          <v-col cols="12" class="pb-0"><v-divider /></v-col>

          <v-col cols="6">
            <div class="mt-0 font-weight-bold">Trạng thái đơn:</div>
            <v-chip :color="getStatusColor(uniformOrderData.status)" small class="white--text mt-1">
              {{ getStatusText(uniformOrderData.status) }}
            </v-chip>
          </v-col>

          <v-col cols="6">
            <div class="mt-0 font-weight-bold">Trạng thái trả:</div>
            <v-chip :color="getStatusReturnColor(uniformOrderData.statusReturned)" small class="white--text mt-1">
              {{ getStatusReturnText(uniformOrderData.statusReturned) }}
            </v-chip>
          </v-col>
          <v-col cols="12" class="pt-1"><v-divider /></v-col>
        </v-row>

        <!-- Danh sách đồng phục -->
        <div class="fix-height-dialog-detail">
          <v-row>
            <v-col cols="12" class="pt-5">
              <div class="font-weight-bold mb-2">Danh sách đồng phục:</div>
              <ul>
                <li v-for="(item, index) in uniformOrderData.uniformItems" :key="index">
                  <v-list-item-content style="padding-top: 0px; padding-bottom: 4px">
                    <span>
                      {{ item.name }} - {{ item.optionOne }} - {{ item.optionTwo }} | SL: {{ item.quantity }} | Đã trả:
                      {{ item.returned || 0 }} | Giá: {{ formatCurrency(item.price) }}
                    </span>
                  </v-list-item-content>
                </li>
              </ul>
              <div class="total-price-wrapper">
                <span>Tổng tiền:</span>
                <span class="total-amount ml-2" style="color: red">{{
                  formatCurrency(uniformOrderData.totalPrice)
                }}</span>
              </div>
            </v-col>
          </v-row>
          <v-col cols="12" class="px-0"><v-divider /></v-col>
          <!-- Ghi chú, ngày đặt -->
          <v-row>
            <v-col cols="12">
              <div class="font-weight-bold mb-1">Ghi chú của phụ huynh:</div>
              <div class="text-muted" style="white-space: pre-wrap">{{ uniformOrderData.note || 'Không có' }}</div>
            </v-col>
            <v-col cols="12" class="px-0 py-0"><v-divider /></v-col>
            <v-col cols="12">
              <div class="font-weight-bold mb-1">Ngày đặt hàng:</div>
              <div>{{ uniformOrderData.orderedAt }}</div>
            </v-col>
            <v-col cols="12" class="px-0 py-0"><v-divider /></v-col>
            <v-col cols="12">
              <div class="font-weight-bold mb-1">Ngày xác nhận đơn:</div>
              <div>{{ formatDate(uniformOrderData.lastConfirmAt) }}</div>
            </v-col>
            <v-col cols="12" class="px-0 py-0"><v-divider /></v-col>
            <v-col cols="12">
              <div class="font-weight-bold mb-1">Ngày trả hàng (lần cuối):</div>
              <div>{{ formatDate(uniformOrderData.lastReturnedAt) }}</div>
            </v-col>
          </v-row>
        </div>
      </v-card-text>

      <v-divider />
      <v-card-actions class="d-flex justify-space-between pa-6">
        <v-btn outlined class="grey--text" @click="cancel">HUỶ</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import CardStudentInfo from '@/components/basic/card/CardStudentInfo.vue'
import { mapActions } from 'vuex'
import moment from 'moment'

export default {
  components: {
    CardStudentInfo,
  },
  props: {
    state: Boolean,
    uniformOrderData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      dialog: false,
      newStatus: '',
      statusOptions: [
        { value: 'pending', text: 'Chờ duyệt' },
        { value: 'confirmed', text: 'Đã xác nhận' },
        { value: 'cancelled', text: 'Đã hủy' },
      ],
    }
  },
  methods: {
    ...mapActions('UniformOrdersRegister', ['updateUniformOrders']),

    formatDate(date) {
      return moment(date).format('DD/MM/YYYY, HH:mm')
    },
    getStatusColor(status) {
      switch (status) {
        case 'pending':
          return '#FFA726' // Màu cam - Chờ duyệt
        case 'confirmed':
          return '#4CAF50' // Màu xanh lá cây - Đã xác nhận
        case 'cancelled':
          return '#616161' // Màu ghi đậm - Đã hủy
        default:
          return '#9E9E9E' // Màu xám tối - Không xác định
      }
    },
    getStatusText(status) {
      const statusTexts = {
        pending: 'Chờ duyệt',
        confirmed: 'Đã xác nhận',
        cancelled: 'Đã hủy',
      }
      return statusTexts[status] || 'Không xác định'
    },
    getStatusReturnText(statusReturned) {
      const map = {
        not_returned: 'Chưa trả',
        waiting_returned: 'Đang trả hàng',
        complete_returned: 'Đã hoàn thành',
      }
      return map[statusReturned] || 'Không xác định'
    },
    getStatusReturnColor(statusReturned) {
      switch (statusReturned) {
        case 'not_returned':
          return '#FFA726'
        case 'waiting_returned':
          return '#FFC107'
        case 'complete_returned':
          return '#4CAF50'
        default:
          return '#9E9E9E'
      }
    },
    formatCurrency(value) {
      return new Intl.NumberFormat('vi-VN', {
        style: 'currency',
        currency: 'VND',
      }).format(value)
    },
    cancel() {
      this.dialog = false
    },
    async confirmChange() {
      if (!this.newStatus) {
        this.$alert.error('Vui lòng chọn trạng thái mới')
        return
      }
      this.$loading.active = true
      try {
        await this.updateUniformOrders({
          id: this.uniformOrderData.id,
          status: this.newStatus,
        })
        this.$alert.addSuccess('Cập nhật trạng thái thành công!')
        this.$emit('updated')
        this.dialog = false
      } catch (error) {
        this.$alert.addError('Có lỗi xảy ra khi cập nhật trạng thái!')
      } finally {
        this.$loading.active = false
      }
    },
  },
  watch: {
    state(val) {
      if (val) {
        this.dialog = true
        this.newStatus = this.uniformOrderData.status === 'pending' ? 'confirmed' : this.uniformOrderData.status
      }
    },
  },
  computed: {
    isStatusDisabled() {
      return (
        (this.uniformOrderData.statusReturned === 'waiting_returned' ||
          this.uniformOrderData.statusReturned === 'complete_returned') &&
        this.uniformOrderData.status === 'confirmed'
      )
    },
  },
}
</script>

<style>
.text-muted {
  color: #888;
  font-size: 14px;
}
.fix-height-dialog-detail {
  height: 200px !important;
  max-height: 300px;
  overflow: auto;
  padding-right: 18px;
}
.total-price-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
  font-weight: bold;
}
ul {
  list-style-type: disc !important;
  margin-left: 20px;
}
</style>
